export const IMAGES = Object.freeze({
  BASE64_PREFIX: 'base64',
})

export const APP_VERSION = '1.1.1'

// Default duration for message banners (in seconds)
export const DEFAULT_MESSAGE_DURATION = 5
